import { DataBean } from "../DataBean";

export class AddBanking extends DataBean {


    public async addBankingConciliationDataInfo(idBankingConciliation:any,description:any,date:any,value:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliation_addBankingConciliationDataInfo_Number_String_java.util.Date_Number", [idBankingConciliation,description,date,value]);
    }

    public async refreshBankingConciliation(idBankingConciliation:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliation_refreshBankingConciliation_Number", [idBankingConciliation]);
    }

    public async uncheckBankingConciliation(idBankingConciliation:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_uncheckBankingConciliation_Number", [idBankingConciliation]);
    }
}